import { isAxiosError } from 'axios';
import type { Message } from '@ag-ui/client';
import { getApiClient } from '../../api/api-client';
import { getPandaStreamURL } from '../../constants/APIconstants';

// Read side of panda-service's threads API: `GET /threads/{id}` returns the
// persisted history — the recovery path when `/connect` can't re-attach.

export interface PandaThreadDetail {
  threadId: string;
  title: string | null;
  createdAt: string;
  updatedAt: string;
  messages: Message[];
}

/** Fetch a thread's persisted history; `null` when it hasn't persisted yet (404). */
export async function fetchThreadDetail(threadId: string): Promise<PandaThreadDetail | null> {
  try {
    // Absolute URL: panda-service, not the client's base URL. Auth still applies.
    return await getApiClient().get<PandaThreadDetail>(`${getPandaStreamURL()}/${threadId}`);
  } catch (err) {
    if (isAxiosError(err) && err.response?.status === 404) return null;
    throw err;
  }
}
